import { lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

// Components
import ProtectedRoute from '@providers/ProtectedRoute';
import ErrorBoundary from '@atoms/ErrorBoundary/ErrorBoundary';
import MainLayout from '@template/MainLayout';
import PaymentRedirectionalLoader from '@atoms/PaymentRedirectionalLoader';
import LoginWidget from '@organism/LoginWidget';
import CreateAccount from '@organism/RegisterPage/CreateAccount';
import LoginCallback from '@organism/LoginCallback';
import PaymentStatus from '@pages/PaymentStatus';
import ResetPassword from '@/components/pages/ResetPassword';

const InvoicePage = lazy(() => import('@pages/InvoicePage'));

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginWidget />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/register',
    element: <CreateAccount />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/login/callback',
    element: <LoginCallback />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: '/invoices',
            element: <InvoicePage />,
          },
          {
            path: '/payment-status',
            element: <PaymentStatus />,
          },
        ],
      },
    ],
  },
  {
    path: '/pay',
    element: <PaymentRedirectionalLoader />,
  },

  {
    path: '*',
    element: <Navigate to="/login" replace />, // Now properly imported
  },
]);
